import React, { useState } from 'react'
import { Tooltip } from 'antd'
import { menuBuilderGpReviewCopy as copy } from 'src/constants/menuBuilderCopy'
import { recipeNeedsGpReview } from 'src/utils/recipeGpReview'

const RecipeGpReviewMarkReviewedLink = ({ recipe, onMarkReviewed }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)

  if (!recipeNeedsGpReview(recipe) || !onMarkReviewed) {
    return null
  }

  const handleClick = async event => {
    event.stopPropagation()
    event.preventDefault()

    if (isSubmitting) {
      return
    }

    setIsSubmitting(true)
    try {
      await onMarkReviewed(recipe)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Tooltip title={copy.markReviewedTooltip}>
      <button
        type='button'
        onClick={handleClick}
        disabled={isSubmitting}
        style={{
          border: 'none',
          background: 'transparent',
          padding: 0,
          color: '#ad6800',
          fontSize: '11px',
          fontWeight: 600,
          cursor: isSubmitting ? 'wait' : 'pointer',
          textDecoration: 'underline',
        }}
      >
        {copy.markReviewedCta}
      </button>
    </Tooltip>
  )
}

export default RecipeGpReviewMarkReviewedLink
